import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom';

export function useStoryblok(query, itemName, resolveRelations) {
    const preview = window.location.search.includes('_storyblok');
    const { loading, data } = useQuery(query);

    const [story, setStory] = useState(null);
    const [error, setError] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (data) {
            if (data?.[itemName]?.items) {
                setStory(data?.[itemName]?.items?.[0]);
            } else {
                setStory(data?.[itemName]);
            }
        }
    }, [data, itemName]);

    useEffect(() => {
        if (!loading && !data?.[itemName]) {
            setError(true);
        }
    }, [loading, data, itemName]);

    function configureBridge() {
        const { StoryblokBridge } = window;
        if (typeof StoryblokBridge !== 'undefined') {
            const storyblokInstance = new StoryblokBridge({
                resolveRelations: resolveRelations,
                preventClicks: true
            });
            storyblokInstance.on(['change', 'published'], () => window.location.reload(true));
            storyblokInstance.on('input', event => {
                setStory(event.story);
            });
        }
    }

    function initEventListeners() {
        if (itemName === 'GlobalItem') {
            if (location.pathname.includes('global/')) {
                configureBridge();
            }
            return null;
        } else if (itemName === 'SqegItem') {
            if (location.pathname.includes('sera-que-e-golpe/')) {
                configureBridge();
            }
            return null;
        } else {
            configureBridge();
        }
    }
    function addBridge(callback) {
        const existingScript = document.getElementById('storyblokBridge');
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = '//app.storyblok.com/f/storyblok-v2-latest.js';
            script.id = 'storyblokBridge';
            document.body.appendChild(script);
            script.onload = () => {
                callback();
            };
        } else {
            callback();
        }
    }

    useEffect(() => {
        if (preview) {
            addBridge(initEventListeners);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preview]);
    return {
        loading,
        error,
        story
    };
}
